import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UnitListItemForEdit } from '@app/models';
import { IEditService, IListService } from '@app/services';

@Injectable()
export class UnitListItemService implements IListService, IEditService<UnitListItemForEdit> {
	endpointBase = '/api/unit-list-items';

	constructor(private readonly http: HttpClient) {}

	getList(fieldName?: string): Observable<any> {
		return this.http.get<any>(this.endpointBase, { params: { fieldName } });
	}

	deleteEntity(id: number): Observable<any> {
		return this.http.delete(`${this.endpointBase}/${id}`);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	getById(id: number): Observable<any> {
		throw new Error('Not Implemented');
	}

	createEntity(entity: UnitListItemForEdit): Observable<any> {
		return this.http.post(this.endpointBase, entity);
	}

	updateEntity(entity: UnitListItemForEdit): Observable<any> {
		return this.http.put(`${this.endpointBase}/${entity.Id}`, entity);
	}

	updatePosition(id: number, positionDifference: number): Observable<any> {
		return this.http.post(`${this.endpointBase}/${id}/change-position`, positionDifference);
	}
}
